import { AdvancedTableRowColumn } from '../../../components'
import { __ } from '../../../shared/i18n'
import {
  AdvancedFormField,
  AdvancedFormFieldBuilder,
  AdvancedFormAttributeType,
} from '../../../components/AdvancedForm/advancedFormTypes'
import {
  AdvancedTableColumns,
  AdvancedTableContentKind,
  AdvancedTableFilterKind,
  AdvancedTableFiltersDef,
} from '../../../components/AdvancedTable'
import { DetailCell } from '../../../api'
import { CAPABILITIES, getActionsTableColumns } from '../../utility/capabilityUtility'

export const VALUES_FILTERS: AdvancedTableFiltersDef = [
  {
    key: 'equalCodes',
    label: __('fields.labels.code'),
    type: AdvancedTableFilterKind.STRING_LIST,
    column: 'code',
    col: 8,
  },
  {
    key: 'description',
    label: __('fields.labels.description'),
    type: AdvancedTableFilterKind.STRING,
    column: 'description',
    col: 8,
  },
  {
    key: 'creationDate',
    label: __('fields.labels.creationDate'),
    type: AdvancedTableFilterKind.DATE_RANGE,
    column: 'creationDate',
    col: 8,
  },
  {
    key: 'lastModifyDate',
    label: __('fields.labels.lastModifyDate'),
    type: AdvancedTableFilterKind.DATE_RANGE,
    column: 'lastModifyDate',
    col: 8,
  },
]

export const VALUES_FIELDS: AdvancedFormField[] = [
  AdvancedFormFieldBuilder.buildText('code', [{ required: true }], 24),
  AdvancedFormFieldBuilder.buildText('description', [{ required: false }], 24),
  AdvancedFormFieldBuilder.buildAttribute('attributes', AdvancedFormAttributeType.SIMPLE, true, '', false),
]

export const VALUES_COLUMNS: AdvancedTableColumns = [
  {
    title: __(`fields.labels.code`),
    key: 'code',
    dataIndex: 'code',
  },
  {
    title: __(`fields.labels.description`),
    key: 'description',
    dataIndex: 'description',
    className: 'stw-extra-medium',
  },
  {
    title: __('fields.labels.enumerationType'),
    key: 'enumerationType.code',
    dataIndex: 'enumerationTypeId',
    className: 'stw-extra-medium',
  },
  {
    key: 'attributes',
    title: __(`fields.labels.attributes.title`),
    dataIndex: 'attributes',
    type: AdvancedTableContentKind.ATTRIBUTES,
  },
  {
    key: 'creationDate',
    title: __(`fields.labels.creationDate`),
    dataIndex: 'creationDate',
    type: AdvancedTableContentKind.DATE_TIME,
  },
  {
    key: 'lastModifyDate',
    title: __(`fields.labels.lastModifyDate`),
    dataIndex: 'lastModifyDate',
    type: AdvancedTableContentKind.DATE_TIME,
  },
  {
    key: 'action',
    className: 'stw-small',
    fixedType: 'right',
    sortable: false,
    unmanageable: true,
    render: (text, record) => (
      <AdvancedTableRowColumn
        actions={getActionsTableColumns(
          record.id,
          '/configuration/settings/enumerations/values',
          CAPABILITIES.RESOURCE_ENUMERATION_VALUE_EDIT
        )}
      />
    ),
  },
]

export const VALUES_DETAIL: DetailCell[] = [
  { title: 'Id', attribute: 'id', columns: 12 },
  { title: __(`fields.labels.code`), attribute: 'code', columns: 12 },
  { title: __(`fields.labels.description`), attribute: 'description', columns: 12 },
  { title: __(`fields.labels.enumerationType`), attribute: 'enumerationType.code', columns: 12 },
  { title: __(`fields.labels.creationDate`), attribute: 'creationDate', type: 'date', columns: 12 },
  { title: __(`fields.labels.lastModifyDate`), attribute: 'lastModifyDate', type: 'date', columns: 12 },
]
